const mediumThumbnailLoadingImages = [
  require('../components/images/thumbnail-loading/thumnail-medium1.jpeg'),
  require('../components/images/thumbnail-loading/thumnail-medium2.jpeg'),
  require('../components/images/thumbnail-loading/thumnail-medium3.jpeg'),
  require('../components/images/thumbnail-loading/thumnail-medium4.jpeg'),
  require('../components/images/thumbnail-loading/thumnail-medium5.jpeg'),
  require('../components/images/thumbnail-loading/thumnail-medium6.jpeg'),
  require('../components/images/thumbnail-loading/thumnail-medium7.jpeg'),
];

const hashString = (value: string): number => {
  let hash = 0;
  for (let index = 0; index < value.length; index += 1) {
    hash = ((hash << 5) - hash + value.charCodeAt(index)) | 0;
  }
  return Math.abs(hash);
};

export const getMediumThumbnailLoadingImage = (seed?: string | number | null): string => {
  const key = seed == null || seed === '' ? 'fable-thumbnail-loading' : String(seed);
  return mediumThumbnailLoadingImages[hashString(key) % mediumThumbnailLoadingImages.length];
};
